export const TOAST_ERROR_DURATION_MS = 5000;

export function showToast(
  message: string,
  timeout = 2000,
  action?: { label: string; href: string; openInNewTab?: boolean; onClick?: () => void },
  type?: 'error',
  iconSrc?: string,
) {
  const alertRegion = type === 'error' ? document.getElementById('toast-alert') : null;
  const toast = alertRegion ?? document.getElementById('toast');

  if (!toast) {
    return;
  }

  document.getElementById(alertRegion ? 'toast' : 'toast-alert')?.classList.remove('toast--show');
  toast.textContent = '';

  if (iconSrc) {
    const iconWrap = document.createElement('span');
    iconWrap.className = 'toast__icon';
    const img = document.createElement('img');
    img.src = iconSrc;
    img.alt = '';
    iconWrap.appendChild(img);
    toast.appendChild(iconWrap);
  }
  toast.classList.toggle('toast--with-icon', Boolean(iconSrc));

  const msg = document.createElement('span');
  msg.textContent = message;
  toast.appendChild(msg);

  if (action) {
    const link = document.createElement('a');
    link.textContent = action.label;
    link.href = action.href;
    if (action.openInNewTab) {
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
    }
    if (action.onClick) {
      const onClick = action.onClick;
      link.addEventListener('click', (e) => {
        e.preventDefault();
        onClick();
      });
    }
    link.className = 'toast__action';
    toast.appendChild(link);
  }

  if (type === 'error') {
    toast.classList.add('toast--error');
  }

  toast.classList.add('toast--show');

  setTimeout(() => {
    toast.classList.remove('toast--show', 'toast--error');
  }, timeout);
}
